<template>
  <div class="main">
    <Header
      :show="true"
      title="卸料排队"
      left="prepage"
      right="create"
      :click-left="handleClickLeft"
      :click-right="handleClickRight"
    />
    <div style="padding-bottom: 8vh">
      <el-table
        ref="table"
        :data="table.data"
        :row-key="handleRowKey"
        @row-click="handleTableRowClick"
      >
        <el-table-column
          type="expand"
          width="30px"
        >
          <template slot-scope="{ row }">
            <el-form
              label-position="left"
              inline
            >
              <div style="display: flex; width: 100%; flex-direction: column">
                <el-form-item label="车牌号">
                  {{ row.vehicleNo }}
                </el-form-item>
                <el-form-item label="卸料口">
                  <el-tag
                    v-if="row.jarType == 1"
                    type="primary"
                  >
                    1 号口
                  </el-tag>
                  <el-tag
                    v-if="row.jarType == 2"
                    type="primary"
                  >
                    2 号口
                  </el-tag>
                </el-form-item>
                <el-form-item label="物料名称">
                  {{ row.materialsName }}
                </el-form-item>
                <el-form-item label="状态">
                  <el-tag
                    v-if="row.status === 0"
                    type="info"
                  >
                    未卸料
                  </el-tag>
                  <el-tag
                    v-if="row.status === 1"
                    type="primary"
                  >
                    卸料中
                  </el-tag>
                  <el-tag
                    v-if="row.status === 2"
                    type="success"
                  >
                    卸料完成
                  </el-tag>
                </el-form-item>
                <el-form-item label="创建时间">
                  {{ row.createTime | formatTime }}
                </el-form-item>
                <el-form-item label="卸料完成时间">
                  {{ row.unloadingTime | formatTime }}
                </el-form-item>
                <el-form-item
                  v-if="checkPermission([534])"
                  label="操作"
                >
                  <el-button
                    v-if="checkPermission([534])"
                    size="mini"
                    type="danger"
                    @click="handleDelete(row)"
                  >
                    删除
                  </el-button>
                </el-form-item>
              </div>
            </el-form>
          </template>
        </el-table-column>
        <el-table-column
          label="序号"
          type="index"
          align="center"
          width="60"
        />
        <el-table-column
          label="车牌号"
          prop="vehicleNo"
          align="center"
        />
        <el-table-column
          label="物料"
          prop="materialsName"
          align="center"
          show-overflow-tooltip
        />
        <el-table-column
          label="状态"
          prop="status"
          align="center"
          show-overflow-tooltip
        >
          <template slot-scope="{ row }">
            <el-tag
              v-if="row.status === 0"
              type="info"
            >
              未卸料
            </el-tag>
            <el-tag
              v-if="row.status === 1"
              type="primary"
            >
              卸料中
            </el-tag>
            <el-tag
              v-if="row.status === 2"
              type="success"
            >
              卸料完成
            </el-tag>
          </template>
        </el-table-column>
      </el-table>
      <div style="height: 1rem; background-color: #ffffff" />
    </div>
    <Footer value="service" />
  </div>
</template>

<script>
import checkPermission from "@/utils/permission";
import { Dialog } from "vant";
import Header from "@/views/components/header/index.vue";
import Footer from "@/views/components/footer/index.vue";
import { getList, del } from "@/api/unloading.js";
import dayjs from "dayjs";

export default {
  name: "ServiceBussinessTruck",
  filters: {
    formatTime(time) {
      if (!time) return time;
      return dayjs(time).format("YYYY-MM-DD HH:mm:ss");
    },
  },
  components: {
    Header,
    Footer,
  },
  inject: ["reload"],
  data() {
    return {
      listQuery: {
        limit: 10,
        page: 1,
      },
      table: {
        listLoading: false,
        fullWidth: document.documentElement.clientWidth,
        key: 0,
        total: 0,
        data: [],
      },
      handleRowKey(row) {
        return row.id;
      },
    };
  },
  computed: {},
  created() {
    this.handleClickQuery();
  },
  methods: {
    checkPermission,
    async handleDelete(row) {
      await Dialog.confirm({
        title: "确认删除此排队？",
        message: "车牌号：" + row.vehicleNo,
        theme: "round-button",
      }).catch(() => {
        this.$toast("取消删除操作");
        throw "取消删除操作";
      });
      await del(row);
      this.$toast("删除成功");
      this.handleClickQuery();
    },
    handleClickLeft() {
      this.$router.go(-1);
    },
    handleClickRight() {
      this.$router.push({
        path: "/service/business/unloading-queue/create",
        query: {},
      });
    },
    handleTableRowClick(row, column, event) {
      this.$refs.table.toggleRowExpansion(row);
    },
    handleClickQuery() {
      const data = {
        page: this.listQuery.page,
        limit: this.listQuery.limit,
      };
      getList(data).then(({ data }) => {
        this.table.total = data.data.length;
        this.table.data = data.data;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
// 系统样式修改
::v-deep .van-field__label {
  width: 25%;
}
// 自定义样式
.main {
  height: 100vh;
  font-size: 2vw;
  background-color: #ffffff; //#F7F8FA;
  overflow-x: hidden;
  // overflow-y:hidden;
  overflow-y: auto;
  // display: flex;
  // justify-content: center;
  // align-items: center;
}

::v-deep .el-table__expanded-cell {
  padding: 0;

  .el-form {
    padding: 4px 12px;

    .el-form-item {
      margin-bottom: 0;

      .el-form-item__label {
        width: 7em;
      }
    }
  }
}
</style>
